import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// The portal has no offline story; the worker exists so a notification can
// reach a partner whose portal is closed. Registered unconditionally, because
// receiving one still needs the partner's explicit switch in Nastavení.
if ("serviceWorker" in navigator) {
  void navigator.serviceWorker.register("/sw.js");
}

createRoot(document.getElementById("root")!).render(<App />);
